import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { Button } from "@mui/material";
import { useHistory } from "react-router";
import TrollImage from "../assets/images/unauthorized.png";
import { useDocTitle } from "../utils";

interface Props {}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#4f88e3",
  },
  pnfOuter: {
    width: "100%",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    color: "#fff",
  },
  pnfImage: {
    marginBottom: 40,
    width: 400,
  },
}));

const PageForbidden = (props: Props) => {
  useDocTitle("Forbidden")
  const classes = useStyles();
  const history = useHistory();

  return (
    <div className={classes.root}>
      <div className={classes.pnfOuter}>
        <img
          alt="trollface"
          className={classes.pnfImage}
          src={TrollImage}
        />
        <Typography variant="h4">Forbidden - You do not have permission to view that page</Typography>
        <Box my={1} />
        <Button size="large" variant="contained" color="primary" onClick={() => history.goBack()}>Go back</Button>
      </div>
      
    </div>
  );
};

export default PageForbidden;
